import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { JupiterInspectionNote } from '../types/jupiter-inspection-note.type';

@Pipe({
  name: 'inspectionNoteTitle',
  pure: false,
})
export class InspectionNoteTitlePipe implements PipeTransform, OnDestroy {
  private subscription: Subscription;

  constructor(cdr: ChangeDetectorRef, private readonly translate: TranslateService) {
    this.subscription = translate.onLangChange.subscribe(() => cdr.markForCheck());
  }

  transform(inspectionNote: JupiterInspectionNote): string {
    const value = inspectionNote.title.trim();
    const translationKey = `JUPITER.${value}`;
    const translated = this.translate.instant(translationKey);

    return translated === translationKey ? value : translated;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
